import { render } from "./BackToLoginLink.vue?vue&type=template&id=ef22a1f8"
import script from "./BackToLoginLink.vue?vue&type=script&lang=js"
export * from "./BackToLoginLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__